// extracted by mini-css-extract-plugin
export default {"accordion":"style_accordion__8+1MT","contAccordion":"style_contAccordion__wZlIt","newsCategory":"style_newsCategory__5opOU","newsSort":"style_newsSort__pMcnR"};